import { useEffect, useState } from "react";
import { Trash2, Star } from "lucide-react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ENTITY_LABEL } from "./ImportHistory";

export default function ImportPresets() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/import/presets").then(({ data }) => setRows(data));
  useEffect(() => { load(); }, []);
  const remove = async (p) => {
    try { await api.delete(`/import/presets/${p.id}`); toast.success("Preset eliminato"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Errore"); }
  };
  return (
    <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="preset-list">
      {rows.map((p) => (
        <div key={p.id} data-testid={`preset-card-${p.id}`} className="bg-white rounded-xl border border-slate-200 p-4">
          <div className="flex items-start justify-between gap-2">
            <div><p className="font-heading font-semibold text-slate-800 flex items-center gap-1.5">{p.system && <Star className="w-3.5 h-3.5 text-amber-500 fill-amber-500" />}{p.name}</p>
              <p className="text-xs text-slate-400 mt-0.5">Source: {p.source || "—"} · {ENTITY_LABEL[p.entity] || "—"} · {p.system ? "di sistema" : "personalizzato"}</p></div>
            {!p.system && <Button variant="ghost" size="sm" data-testid={`delete-preset-${p.id}`} onClick={() => remove(p)} className="text-red-500 h-7 px-2"><Trash2 className="w-4 h-4" /></Button>}
          </div>
          <div className="mt-3 text-xs space-y-0.5 max-h-40 overflow-y-auto kanban-scroll">
            {Object.entries(p.mapping || {}).filter(([, v]) => v).map(([col, f]) => <div key={col} className="flex justify-between gap-2"><span className="text-slate-500 truncate">{col}</span><span className="font-mono text-teal-700 truncate">{f}</span></div>)}
            {!Object.values(p.mapping || {}).some(Boolean) && <p className="text-slate-400">Mapping automatico per sinonimi</p>}
          </div>
          {p.signature?.length > 0 && <p className="text-[10px] text-slate-400 mt-2">Riconoscimento: {p.signature.join(", ")}</p>}
        </div>
      ))}
    </div>
  );
}
